module.exports = __webpack_public_path__ + "static/media/webvision8.6add5996.png";